import { PicturePerfect } from './PicturePerfect';

export default PicturePerfect;
